/* eslint-disable prettier/prettier */
/* prettier-ignore-file */
/* eslint-disable */

import { useState } from 'react';
import { userService, AdminCourseDashboard } from '../services/userService';

export function useAdminDashboard() {
	const [dashboard, setDashboard] = useState<AdminCourseDashboard | null>(
		null
	);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);

	const fetchDashboard = async (filters?: {
		coachId?: string;
		courseId?: string;
		inviteStatus?: string;
		search?: string;
		page?: number;
		limit?: number;
	}) => {
		setLoading(true);
		setError(null);

		try {
			const data = await userService.getAdminDashboard(filters);
			setDashboard(data);
		} catch (err: any) {
			console.error('Admin dashboard error:', err);
			setError(err.message || 'Failed to fetch dashboard');
		} finally {
			setLoading(false);
		}
	};

	return {
		dashboard,
		loading,
		error,
		fetchDashboard,
	};
}
